import styled from 'styled-components';

import { size } from '../../layout/helpers';

export const Wrapper = styled.div.attrs(() => ({
  role: 'status',
  'aria-hidden': true,
}))`
  display: contents;
`;

export const TextBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size(0.5)};
`;

export const HiddenMd = styled.div`
  ${(props) => props.theme.breakpoint.Md} {
    display: none;
  }
`;

export const HiddenLtMd = styled.div`
  ${(props) => props.theme.breakpoint.LtMd} {
    display: none;
  }
`;

// Horizontal Overflow List

export const DummyOverflow = styled.div`
  ${(props) => props.theme.breakpoint.LtSm} {
    overflow: hidden;
    margin: 0 var(--main-gutter-negative);
  }
`;

export const DummyOverflowList = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;

  ${(props) => props.theme.breakpoint.LtSm} {
    padding: 0 var(--main-gutter);
  }
`;

export const DummyOverflowListItem = styled.li`
  & + & {
    margin-left: ${size(1)};
  }
`;

// Page Header

export const DummyPageHeader = styled.div`
  --dummy-page-header-gap: ${size(2)};

  margin-bottom: var(--dummy-page-header-gap);
  padding-bottom: var(--dummy-page-header-gap);
  border-bottom: 1px solid var(--c-border-main);

  ${(props) => props.theme.breakpoint.Md} {
    --dummy-page-header-gap: ${size(3)};

    margin-bottom: ${size(7)};
  }
`;

export const DummyPageHeaderMenu = styled.div`
  margin-bottom: var(--dummy-page-header-gap);

  ${(props) => props.theme.breakpoint.Lg} {
    display: none;
  }
`;

export const DummyPageHeaderMain = styled.div`
  ${(props) => props.theme.breakpoint.Md} {
    display: flex;
    justify-content: space-between;
  }
`;

export const DummyPageHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${size(2)};

  ${(props) => props.theme.breakpoint.Md} {
    flex: 1 1 auto;
    max-width: 50%;
  }
`;

export const DummyPageHeaderCta = styled.div`
  ${(props) => props.theme.breakpoint.LtMd} {
    margin-top: var(--dummy-page-header-gap);
  }

  ${(props) => props.theme.breakpoint.Md} {
    flex-shrink: 0;
  }
`;

export const DummyPageHeaderBreadcrumbs = styled.div`
  display: flex;
  align-items: center;
  gap: ${size(0.5)};
  margin-bottom: var(--dummy-page-header-gap);
`;
